/* Bloody Good Box – Geschenkbox selbst packen (gbx). Gehört zu sections/gbx-geschenkbox.liquid.
   Alle Texte stehen im HTML (Weglot). Das Skript blendet nur ein/aus und schreibt Zahlen in notranslate-Spans. */
(function () {
  'use strict';
  var root = document.getElementById('gbx');
  if (!root) return;

  var SLOTS = 4;
  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function show(el, on) { if (el) el.hidden = !on; }
  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }

  var nf;
  try {
    nf = new Intl.NumberFormat(root.dataset.locale || 'de', { style: 'currency', currency: root.dataset.currency || 'EUR' });
  } catch (e) {
    nf = new Intl.NumberFormat('de', { style: 'currency', currency: 'EUR' });
  }
  function money(cents) { return nf.format((cents || 0) / 100); }

  var BOX_VARIANT = Number(root.dataset.boxVariant) || 0;
  var BOX_PRICE = Number(root.dataset.boxPrice) || 0;
  var FREE = Number(root.dataset.free) || 0;
  var GRUSS_KEY = root.dataset.grussKey || 'Grußkarte';
  var ROUTE_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_URL = root.dataset.cart || '/cart';

  var grindLabels = {};
  $$('[data-gbx-gl]').forEach(function (el) { grindLabels[el.getAttribute('data-gbx-gl')] = el.textContent.trim(); });
  function grindLabel(g) { return grindLabels[g] || g; }

  var cards = $$('[data-gbx-card]').map(function (el) {
    var variants = [];
    try { variants = JSON.parse($('[data-gbx-variants]', el).textContent); } catch (e) { variants = []; }
    return {
      el: el, key: el.dataset.key, tab: el.dataset.tab, roast: el.dataset.roast, variants: variants,
      nameEl: $('[data-gbx-name]', el), priceEl: $('[data-gbx-price]', el), grindEl: $('[data-gbx-grind]', el),
      addBtn: $('[data-gbx-add]', el), removeBtn: $('[data-gbx-remove-one]', el),
      inbox: $('[data-gbx-inbox]', el), inboxN: $('[data-gbx-inbox] [data-n]', el)
    };
  });
  var byKey = {};
  cards.forEach(function (c) { if (!byKey[c.key]) byKey[c.key] = c; });
  function cardImg(c) { var i = $('img', c.el); return i ? (i.currentSrc || i.src) : ''; }
  function cardName(c) { return c.nameEl ? c.nameEl.textContent.trim() : ''; }

  var methods = $$('[data-gbx-method]').map(function (b) {
    return { b: b, id: b.dataset.gbxMethod, roast: b.dataset.roast || '', grind: (b.dataset.grind || '').split('|').filter(Boolean), canGrinder: b.dataset.grinder === '1' };
  });
  var tabBtns = $$('[data-gbx-tab]');
  var firstTab = 'all';
  for (var t = 0; t < tabBtns.length; t++) { if (tabBtns[t].dataset.gbxTab !== 'all') { firstTab = tabBtns[t].dataset.gbxTab; break; } }

  var state = { method: null, grinder: false, tab: firstTab, slots: [null, null, null, null], msg: '' };

  function wholeVariant(c) {
    var hit = c.variants.filter(function (v) { return v.g === 'ganze Bohne'; });
    return hit.filter(function (v) { return v.a; })[0] || hit[0] || c.variants[0] || null;
  }

  function resolve(c) {
    var m = state.method;
    var fits = !m || !m.roast || c.roast === 'B' || c.roast === m.roast;
    var wanted = (!m || !m.grind.length || state.grinder) ? ['ganze Bohne'] : m.grind.concat(['gemahlen']);
    var v = null;
    for (var i = 0; i < wanted.length && !v; i++) {
      var hit = c.variants.filter(function (x) { return x.g === wanted[i]; });
      if (hit.length) v = hit.filter(function (x) { return x.a; })[0] || hit[0];
    }
    return { fits: fits, v: v, grindOk: !!v, available: !!(v && v.a) };
  }

  function filledCount() { return state.slots.filter(Boolean).length; }

  function render() {
    var m = state.method;
    var filled = filledCount();
    var free = SLOTS - filled;

    methods.forEach(function (x) { x.b.setAttribute('aria-pressed', String(m === x)); });
    $$('[data-gbx-hint]').forEach(function (el) { el.hidden = el.getAttribute('data-gbx-hint') !== (m ? m.id : ''); });
    show($('[data-gbx-grinder-wrap]'), !!(m && m.canGrinder));
    var gi = $('[data-gbx-grinder]');
    if (gi) gi.checked = state.grinder;

    var counts = { all: 0 };
    var seenAll = {};
    var seenTab = {};
    var shown = 0;
    cards.forEach(function (c) {
      var r = resolve(c);
      var visible = false;
      if (r.fits) {
        seenTab[c.tab] = seenTab[c.tab] || {};
        var firstInTab = !seenTab[c.tab][c.key];
        seenTab[c.tab][c.key] = true;
        var firstAll = !seenAll[c.key];
        seenAll[c.key] = true;
        if (firstInTab) counts[c.tab] = (counts[c.tab] || 0) + 1;
        if (firstAll) counts.all += 1;
        visible = state.tab === 'all' ? firstAll : (c.tab === state.tab && firstInTab);
      }
      c.el.hidden = !visible;
      if (visible) shown += 1;

      var shownV = r.v || wholeVariant(c);
      if (c.priceEl && shownV) c.priceEl.textContent = money(shownV.p);
      if (c.grindEl) c.grindEl.textContent = r.grindOk ? grindLabel(r.v.g) : grindLabel('nur ganze Bohne');
      var n = state.slots.filter(function (k) { return k === c.key; }).length;
      var label = !r.grindOk ? 'whole' : (!r.available ? 'sold' : (free === 0 ? 'full' : 'add'));
      $$('[data-l]', c.addBtn).forEach(function (s) { s.hidden = s.getAttribute('data-l') !== label; });
      c.addBtn.disabled = label !== 'add';
      c.el.classList.toggle('is-sold', r.grindOk && !r.available);
      show(c.inbox, n > 0);
      if (c.inboxN) c.inboxN.textContent = String(n);
      show(c.removeBtn, n > 0);
    });

    tabBtns.forEach(function (b) {
      var id = b.dataset.gbxTab;
      b.setAttribute('aria-pressed', String(id === state.tab));
      var cnt = $('[data-gbx-count]', b);
      if (cnt) cnt.textContent = '(' + (counts[id] || 0) + ')';
    });
    $$('[data-gbx-intro]').forEach(function (el) { el.hidden = el.getAttribute('data-gbx-intro') !== state.tab; });
    show($('[data-gbx-empty]'), shown === 0);

    var conflict = false;
    var sum = 0;
    $$('[data-gbx-slot]').forEach(function (slot, i) {
      var key = state.slots[i];
      show($('[data-empty]', slot), !key);
      show($('[data-full]', slot), !!key);
      $$('[data-warn]', slot).forEach(function (w) { w.hidden = true; });
      slot.classList.toggle('is-filled', !!key);
      if (!key) { slot.classList.remove('is-warn'); return; }
      var c = byKey[key];
      var r = resolve(c);
      var warn = !r.fits ? (c.roast === 'F' ? 'roast-f' : 'roast-e') : (!r.grindOk ? 'grind' : (!r.available ? 'sold' : ''));
      if (warn) { conflict = true; show($('[data-warn="' + warn + '"]', slot), true); }
      slot.classList.toggle('is-warn', !!warn);
      var v = r.v || wholeVariant(c);
      sum += v ? v.p : 0;
      var img = $('[data-img]', slot);
      var src = cardImg(c);
      if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      $('[data-name]', slot).textContent = cardName(c);
      $('[data-name-sr]', slot).textContent = cardName(c);
      $('[data-grind]', slot).textContent = v ? grindLabel(r.grindOk ? v.g : 'nur ganze Bohne') : '';
      $('[data-price]', slot).textContent = v ? money(v.p) : '';
    });

    var total = sum + BOX_PRICE;
    setText('[data-n="filled"]', String(filled));
    setText('[data-n="coffee"]', money(sum));
    setText('[data-n="total"]', money(total));
    setText('[data-n="free"]', String(free));

    var ship = !FREE ? '' : (filled === 0 ? 'base' : (total >= FREE ? 'ok' : 'miss'));
    $$('[data-ship]').forEach(function (el) { el.hidden = el.getAttribute('data-ship') !== ship; });
    if (FREE) setText('[data-n="miss"]', money(Math.max(FREE - total, 0)));

    var st = conflict ? 'conflict' : (filled === 0 ? 'empty' : (free === 1 ? 'need1' : (free > 1 ? 'needn' : 'full')));
    $$('[data-st]').forEach(function (el) { el.hidden = el.getAttribute('data-st') !== st; });
    var stWrap = $('[data-gbx-status]');
    if (stWrap) stWrap.classList.toggle('is-warn', conflict);

    var cta = $('[data-gbx-cta]');
    if (cta && !cta.dataset.busy) cta.disabled = !(filled === SLOTS && !conflict && BOX_VARIANT);
    var sur = $('[data-gbx-surprise]');
    if (sur) sur.disabled = free === 0;
    $$('[data-gbx-clear]').forEach(function (b) {
      if (b.hasAttribute('data-hide-empty')) b.hidden = filled === 0;
      else b.disabled = filled === 0;
    });

    var hasMsg = state.msg.trim().length > 0;
    $$('[data-ms]').forEach(function (el) { el.hidden = el.getAttribute('data-ms') !== (hasMsg ? 'set' : 'empty'); });
  }

  function addKey(key) {
    var i = state.slots.indexOf(null);
    if (i < 0) return;
    state.slots[i] = key;
    feedback(null);
    render();
  }
  function removeAt(i) {
    state.slots.splice(i, 1);
    state.slots.push(null);
    feedback(null);
    render();
  }

  function surprise() {
    var lists = [];
    $$('[data-gbx-tab][data-surprise="1"]').forEach(function (b) {
      var id = b.dataset.gbxTab;
      lists.push(cards.filter(function (c) { return c.tab === id; }));
    });
    var used = {};
    state.slots.forEach(function (k) { if (k) used[k] = true; });
    var progress = true;
    while (state.slots.indexOf(null) > -1 && progress) {
      progress = false;
      for (var l = 0; l < lists.length && state.slots.indexOf(null) > -1; l++) {
        var pick = lists[l].filter(function (c) {
          var r = resolve(c);
          return !used[c.key] && r.fits && r.grindOk && r.available;
        })[0];
        if (pick) { state.slots[state.slots.indexOf(null)] = pick.key; used[pick.key] = true; progress = true; }
      }
    }
    feedback(null);
    render();
  }

  function feedback(key, detail) {
    $$('[data-fb]').forEach(function (el) { el.hidden = el.getAttribute('data-fb') !== key; });
    var d = $('[data-fb-detail]');
    if (d) d.textContent = detail || '';
  }

  function addToCart() {
    var cta = $('[data-gbx-cta]');
    if (!BOX_VARIANT) { feedback('nobox'); return; }
    if (filledCount() !== SLOTS) return;
    cta.disabled = true;
    cta.dataset.busy = '1';
    feedback('busy');
    var done = function () { delete cta.dataset.busy; render(); };
    fetch(ROUTE_ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var dup = (cart.items || []).some(function (it) { return Number(it.variant_id) === BOX_VARIANT; });
        if (dup) { feedback('dup'); done(); return null; }
        var boxId = 'GB-' + Date.now().toString(36).toUpperCase();
        var qty = {};
        var order = [];
        state.slots.forEach(function (k) {
          var v = resolve(byKey[k]).v;
          if (!qty[v.id]) { qty[v.id] = 0; order.push(v.id); }
          qty[v.id] += 1;
        });
        var items = order.map(function (id) { return { id: id, quantity: qty[id], properties: { _Geschenkbox: boxId } }; });
        var boxProps = { _Geschenkbox: boxId };
        var msg = state.msg.trim();
        if (msg) boxProps[GRUSS_KEY] = msg;
        items.push({ id: BOX_VARIANT, quantity: 1, properties: boxProps });
        return fetch(ROUTE_ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble', sections_url: window.location.pathname })
        }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok || res.data.status) { feedback('err', res.data.description || res.data.message || ''); done(); return; }
            feedback('ok');
            done();
            document.dispatchEvent(new CustomEvent('gbx:added', { detail: { boxId: boxId, items: items } }));
            var mc = document.querySelector('mini-cart');
            var drawerOn = window.theme && window.theme.shopSettings && window.theme.shopSettings.cartDrawer;
            if (drawerOn && mc && typeof mc.renderContents === 'function' && res.data.sections) {
              try { mc.renderContents(res.data); } catch (e) { window.location.href = CART_URL; }
            } else {
              window.location.href = CART_URL;
            }
          });
      })
      .catch(function (e) {
        if (window.console) console.error('[gbx]', e);
        feedback('err', '');
        done();
      });
  }

  // Events
  methods.forEach(function (x) {
    x.b.addEventListener('click', function () {
      state.method = x;
      if (!x.canGrinder) state.grinder = false;
      render();
    });
  });
  var grinderInput = $('[data-gbx-grinder]');
  if (grinderInput) grinderInput.addEventListener('change', function () { state.grinder = grinderInput.checked; render(); });
  tabBtns.forEach(function (b) { b.addEventListener('click', function () { state.tab = b.dataset.gbxTab; render(); }); });
  cards.forEach(function (c) {
    c.addBtn.addEventListener('click', function () { addKey(c.key); });
    if (c.removeBtn) c.removeBtn.addEventListener('click', function () {
      var i = state.slots.lastIndexOf(c.key);
      if (i > -1) removeAt(i);
    });
  });
  $$('[data-gbx-slot]').forEach(function (slot, i) {
    var b = $('[data-remove]', slot);
    if (b) b.addEventListener('click', function () { removeAt(i); });
  });
  $$('[data-gbx-clear]').forEach(function (b) {
    b.addEventListener('click', function () { state.slots = [null, null, null, null]; feedback(null); render(); });
  });
  var sur = $('[data-gbx-surprise]');
  if (sur) sur.addEventListener('click', surprise);

  var ta = $('[data-gbx-msg]');
  var prev = $('[data-gbx-preview]');
  var prevEmpty = prev ? prev.textContent : '';
  function syncMsg() {
    state.msg = ta.value;
    setText('[data-n="len"]', String(ta.value.length));
    if (prev) {
      prev.textContent = ta.value.trim() ? ta.value : prevEmpty;
      prev.classList.toggle('is-empty', !ta.value.trim());
    }
    render();
  }
  if (ta) {
    ta.addEventListener('input', syncMsg);
    $$('[data-gbx-suggest]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = $('[data-text]', b);
        ta.value = (t ? t.textContent : b.textContent).trim().slice(0, Number(ta.getAttribute('maxlength')) || 200);
        syncMsg();
        ta.focus();
      });
    });
  }
  var ctaBtn = $('[data-gbx-cta]');
  if (ctaBtn) ctaBtn.addEventListener('click', addToCart);

  var mbar = $('.gbx-mbar');
  var boxEl = $('#gbx-box');
  if (mbar && boxEl && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      mbar.classList.toggle('is-off', entries[0].isIntersecting);
    }, { threshold: 0.15 }).observe(boxEl);
  }

  root.classList.add('gbx-ready');
  render();
})();
